module.exports = __webpack_public_path__ + "img/es.5bff949c.png";